import { useState } from "react";

import { hasPermission } from "@hz/common/roles";

import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";

import { Box, Flex, HStack, Separator, Text, VStack } from "@chakra-ui/react";

import { Button } from "@components/ui/button";


import { selectMondayState } from "@state/mondaySlice";

function TroubleshootPage() {
  const [isForceResyncModalOpen, setIsForceResyncModalOpen] = useState(false);
  const { context, subscription, init } = useSelector(selectMondayState);
  const { role, stage } = init;

  const canForceSync = hasPermission(role, "invoices", "force-sync");

  const appInfo = {
    "App ID": context?.app.id,
    "Version Number": context?.appVersion.versionData.displayNumber,
    Name: context?.appVersion.name,
    "Plan ID": subscription?.plan_id,
    "Billing Period": subscription?.billing_period,
    Setup: stage,
    "Your Role": role,
  };

  return (
    <>
      <Flex
        align="start"
        direction="column"
        flex="1"
        maxW="2xl"
      >
        <Text
          fontSize="lg"
          fontWeight="medium"
        >
          Troubleshoot
        </Text>
        <Text
          fontSize="sm"
          color="gray.600"
        >
          QuickBooks for monday.com by Stackfully
        </Text>

        <Separator
          my="24px"
          w="full"
        />

        <VStack
          align="stretch"
          gap="14px"
          width="60%"
          color="gray.600"
          bg="gray.50"
          borderRadius="md"
          p="20px"
        >
          {Object.entries(appInfo).map(([key, value]) => (
            <HStack
              key={key}
              justify="space-between"
              width="100%"
            >
              <Text
                fontWeight="medium"
                color="gray.600"
                fontSize="sm"
              >
                {key}:
              </Text>
              <Text fontSize="sm">{value}</Text>
            </HStack>
          ))}
        </VStack>

        <Box>
          <Text
            fontSize="lg"
            fontWeight="medium"
            my="20px"
          >
            Force re-sync
          </Text>

          <Button
            colorPalette="red"
            disabled={!canForceSync}
            onClick={() => setIsForceResyncModalOpen(true)}
          >
            Force re-sync invoices
          </Button>
        </Box>
      </Flex>

    
    </>
  );
}

export default TroubleshootPage;
